import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';

const CustomersDonut = () => {
  const data = [
    { name: 'New Customers', value: 34249, color: '#B4E50D' },
    { name: 'Repeated', value: 1420, color: '#B4E50D' },
  ];

  return (
    <div className="flex flex-col items-center">
      <div className="h-[300px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              innerRadius={60}
              outerRadius={80}
              paddingAngle={5}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Legend wrapperStyle={{ color: '#FFFFFF' }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="flex justify-around w-full mt-4">
        {data.map((entry, index) => (
          <div key={index} className="text-center">
            <div className="text-2xl font-bold text-[#FFFFFF]">{entry.value.toLocaleString()}</div>
            <div className="text-[#B0B0B0]">{entry.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomersDonut;